import { render, staticRenderFns } from "./DnFaculty.vue?vue&type=template&id=e0a42a44&scoped=true&"
import script from "./DnFaculty.vue?vue&type=script&lang=js&"
export * from "./DnFaculty.vue?vue&type=script&lang=js&"
import style0 from "./DnFaculty.vue?vue&type=style&index=0&id=e0a42a44&lang=scss&scoped=true&"
import style1 from "./DnFaculty.vue?vue&type=style&index=1&id=e0a42a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a42a44",
  null
  
)

export default component.exports